import * as React from 'react';
import PropTypes from 'prop-types';

// Api
import { useGetDashboardUrl } from './api/hooks/useGetDashboardUrl';

// Components
import { Spinner } from '../../components/Spinner';
import { DashboardIframe } from './DashboardIframe';

export const App = ({ userContext }) => {
    const { sessionToken } = userContext;
    const dashboardUrlQuery = useGetDashboardUrl(sessionToken);

    if (dashboardUrlQuery.isLoading) <Spinner />;
    return !dashboardUrlQuery.data ? (
        <span>URL undefined</span>
    ) : (
        <DashboardIframe url={dashboardUrlQuery.data}></DashboardIframe>
    );
};

export default App;

App.propTypes = {
    userContext: PropTypes.object
};
